module.exports = __webpack_public_path__ + "img/profile-user.8e03cfaf.svg";